<div class="camera-feed-container" [ngClass]="{ 'is-loading': camera.state === CameraState.Loading }" #container></div>

@if (showCapture) {
  <button
    class="button is-fullwidth"
    [ngClass]="{
      'is-secondary': camera.state === CameraState.Loading,
      'is-primary': camera.state === CameraState.Activated,
      'is-failure': camera.state === CameraState.Deactivated || camera.state === CameraState.Uninitialized
    }"
    (click)="onCameraAction()"
  >
    <span class="icon">
      <i class="camera-feed-button-icon" [lvIcon]="camera.state === CameraState.Loading ? 'spinner' : 'camera'"></i>
    </span>

    @switch (camera.state) {
      @case (CameraState.Activated) {
        <span translate>app.capture-photo</span>
      }
      @case (CameraState.Loading) {
        <span translate>app.starting-camera</span>
      }
      @default {
        <span translate>app.reconnect-camera</span>
      }
    }
  </button>
}
